import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { genericApi } from '../../common/apiconfig';
import moment from 'moment';
import LinkIcon from '../../img/link.svg';
import AttachFileIcon from '../../img/Attach02.svg';

const StickyNotes = (props) => {
    const { data, onDelete, accountType } = props;

    const [error, setError] = useState(null);
    const colorPairs = [
        { background: "#FFF380", border: "#FFF700" },
        { background: "#FFB6C1", border: "#FF1493" },
        { background: "#90EE90", border: "#39FF14" },
        { background: "#FFD580", border: "#FF6700" },
    ];

    const formatDate = (timestamp) => {
        return moment(timestamp).format("MMM DD YYYY");
    };

    const handleDelete = async (noteId) => {
        let requestBody = JSON.stringify({
            query: `
           mutation
{      
  deleteStudySiteNote(noteId:"${noteId}") {
    code
    type
    message
    attributes
  }
}`});
        try {
            let res = await genericApi("getStudySiteNote", requestBody);
            if (res) {
                onDelete();
            } else {
                setError("Error fetching notes data.");
            }
        } catch (err) {
            console.error("Error fetching study notes:", err);
            setError("Failed to fetch data.");
        }
    };
    const handleViewNotes = async (data) => {
        await props.updateNotesData(data);
        if (accountType === "Site") {
            props.history.push('/site/study/notes/view');
        }
        else {
            props.history.push('/account/studyDetails/site/siteDetails/notes/view');
        }
    }

    return (
        <>
            {data
                ?.filter(item => !(accountType === "Site" && item?.sn?.noteType !== "External"))
                .map((item, key) => {
                    const randomPair = colorPairs[key % colorPairs.length];
                    const docCount = item.document?.length;
                    const linkCount = item.link?.length;

                    return (
                        <div
                            key={key}
                            style={{
                                backgroundColor: randomPair.background,
                                borderRadius: '10px',
                                height: '185px',
                                width: '200px',
                                position: 'relative',
                                overflow: 'hidden',
                                cursor: 'pointer'
                            }}
                            onClick={() => handleViewNotes(item)}
                        >
                            <div style={{ position: 'relative' }}>
                                <h6 className='p-1 pl-2'>{item.sn.title}:</h6>
                                <p className='m-2'
                                    style={{
                                        flexGrow: 1,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {item.sn.notes}
                                </p>
                                <div style={{ position: 'absolute', bottom: 0, top: 114, display: 'flex', flexDirection: 'row', alignItems: 'start', justifyItems: 'center', gap: '5px' }}>
                                    {docCount > 0 && (
                                        <div className='d-flex flex-row items-center'>
                                            <img src={AttachFileIcon} className="text-success ml-2"
                                                style={{ width: "12px", height: "20px" }} />
                                            <p>{docCount}</p>
                                        </div>
                                    )}
                                    {linkCount > 0 && (
                                        <div className='d-flex flex-row'>
                                            <img src={LinkIcon} className="text-success"
                                                 style={{ width: "12px", height: "20px",marginLeft:docCount ? '':'10px' }} />
                                            <p
                                                style={{ cursor: "pointer" }}
                                                className='pl-1'
                                            >
                                                {linkCount}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                <div style={{ borderBottom: `2px solid ${randomPair.border}`, margin: '2px' }}></div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    margin: '5px'
                                }}>
                                    <p>{formatDate(item.sn.createdTs)}</p>
                                </div>
                            </div>
                        </div>
                    );
                })
            }

        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateNotesData: (obj) => {
            return dispatch(
                {
                    type: 'updateNotesData',
                    value: obj,
                }
            )
        },

    }
}
export default withRouter(connect(null, mapDispatchToProps)(StickyNotes));


